import React from "react";
import { PAchartUsersMethods } from "./dashboard/PAchartUsersMethods";
import { FormGroup } from "xsolla-uikit";

export function PAchart2() {
  return (
    <div>
      <div
        className="balance-chart__metrics"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 49%)",
          gridColumnGap: "1%",
          gridRowGap: "36px",
        }}
      >
        <div className="balance-chart__metrics__metric">
          <div className="balance-chart__metrics__metric__name">
            Gross revenue
          </div>
          <div
            className="balance-chart__metrics__metric__value balance-chart__metrics__metric__value--non-zero"
            data-id="balance-chart__metrics__metric__value_gross_revenue"
          >
            $33,135.05
          </div>
          <div className="balance-chart__metrics__metric__change">
            <div className="balance-chart__metrics__metric__change__arrow balance-chart__metrics__metric__change__arrow--gross" />
            <div className="balance-chart__metrics__metric__change__percent balance-chart__metrics__metric__change__percent--gross">
              7.01%
            </div>
            <div className="balance-chart__metrics__metric__change__name">
              Compared to the previous 30 days
            </div>
          </div>
        </div>
        <div className="balance-chart__metrics__metric">
          <div className="balance-chart__metrics__metric__name">Payments</div>
          <div
            className="balance-chart__metrics__metric__value balance-chart__metrics__metric__value--non-zero"
            data-id="balance-chart__metrics__metric__value_transactions_count"
          >
            552
          </div>
          <div className="balance-chart__metrics__metric__change">
            <div className="balance-chart__metrics__metric__change__arrow balance-chart__metrics__metric__change__arrow--gross" />
            <div className="balance-chart__metrics__metric__change__percent balance-chart__metrics__metric__change__percent--gross">
              13.11%
            </div>
            <div className="balance-chart__metrics__metric__change__name">
              Compared to the previous 30 days
            </div>
          </div>
        </div>
        <div className="balance-chart__metrics__metric" style={{ border: 0 }}>
          <div className="balance-chart__metrics__metric__name">
            Paying users
          </div>
          <div
            className="balance-chart__metrics__metric__value balance-chart__metrics__metric__value--non-zero"
            data-id="balance-chart__metrics__metric__value_active_users"
          >
            594
          </div>
          <div className="balance-chart__metrics__metric__change">
            <div className="balance-chart__metrics__metric__change__arrow" />
            <div className="balance-chart__metrics__metric__change__percent">
              0%
            </div>
            <div className="balance-chart__metrics__metric__change__name">
              Compared to the previous 30 days
            </div>
          </div>
        </div>
        <div className="balance-chart__metrics__metric">
          <div className="balance-chart__metrics__metric__name">
            Average payment value
          </div>
          <div
            className="balance-chart__metrics__metric__value balance-chart__metrics__metric__value--non-zero"
            data-id="balance-chart__metrics__metric__value_average_sale"
          >
            $59.67
          </div>
          <div className="balance-chart__metrics__metric__change">
            <div className="balance-chart__metrics__metric__change__arrow balance-chart__metrics__metric__change__arrow--lose" />
            <div className="balance-chart__metrics__metric__change__percent balance-chart__metrics__metric__change__percent--lose">
              -5.29%
            </div>
            <div className="balance-chart__metrics__metric__change__name">
              Compared to the previous 30 days
            </div>
          </div>
        </div>
      </div>
      <div className="balance-chart__chart">
        <div
          className="recharts-responsive-container"
          style={{ width: "100%", height: 330 }}
        >
          <div
            className="recharts-wrapper"
            style={{
              position: "relative",
              cursor: "default",
              width: 800,
              height: 330,
              overflow: "hidden",
            }}
          >
            <svg
              className="recharts-surface"
              width={800}
              height={330}
              viewBox="0 0 800 330"
              version="1.1"
            >
              <clipPath id="recharts3-clip">
                <rect x={60} y={48} height={258} width={800} />
              </clipPath>
              <g className="recharts-cartesian-grid">
                <g className="recharts-cartesian-grid-horizontal">
                  <line
                    stroke="#d6e0e7"
                    fill="none"
                    x={60}
                    y={48}
                    width={1256}
                    height={258}
                    x1={60}
                    y1={306}
                    x2={1316}
                    y2={306} />
                  <line
                    stroke="#d6e0e7"
                    fill="none"
                    x={60}
                    y={48}
                    width={1256}
                    height={258}
                    x1={60}
                    y1="241.5"
                    x2={1316}
                    y2="241.5" />
                  <line
                    stroke="#d6e0e7"
                    fill="none"
                    x={60}
                    y={48}
                    width={1256}
                    height={258}
                    x1={60}
                    y1={177}
                    x2={1316}
                    y2={177} />
                  <line
                    stroke="#d6e0e7"
                    fill="none"
                    x={60}
                    y={48}
                    width={1256}
                    height={258}
                    x1={60}
                    y1="112.5"
                    x2={1316}
                    y2="112.5" />
                  <line
                    stroke="#d6e0e7"
                    fill="none"
                    x={60}
                    y={48}
                    width={1256}
                    height={258}
                    x1={60}
                    y1={48}
                    x2={1316}
                    y2={48} />
                </g>
              </g>
              <g className="recharts-layer recharts-cartesian-axis recharts-xAxis xAxis">
                <g className="recharts-cartesian-axis-ticks">
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="122.80000000000001"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="122.80000000000001" dy="0.71em">
                        04/23
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="206.53333333333333"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="206.53333333333333" dy="0.71em">
                        04/25
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="290.2666666666667"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="290.2666666666667" dy="0.71em">
                        04/27
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x={374}
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x={374} dy="0.71em">
                        04/29
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="457.73333333333335"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="457.73333333333335" dy="0.71em">
                        05/01
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="541.4666666666666"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="541.4666666666666" dy="0.71em">
                        05/03
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="625.1999999999999"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="625.1999999999999" dy="0.71em">
                        05/05
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="708.9333333333333"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="708.9333333333333" dy="0.71em">
                        05/07
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="792.6666666666666"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="792.6666666666666" dy="0.71em">
                        05/09
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="876.4"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="876.4" dy="0.71em">
                        05/11
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="960.1333333333333"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="960.1333333333333" dy="0.71em">
                        05/13
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="1043.8666666666668"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="1043.8666666666668" dy="0.71em">
                        05/15
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="1127.6000000000001"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="1127.6000000000001" dy="0.71em">
                        05/17
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="1211.3333333333335"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="1211.3333333333335" dy="0.71em">
                        05/19
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <text
                      height={24}
                      width={1256}
                      x="1295.0666666666668"
                      y={314}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="middle"
                    >
                      <tspan x="1295.0666666666668" dy="0.71em">
                        05/21
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g className="recharts-layer recharts-cartesian-axis recharts-yAxis yAxis">
                <g className="recharts-cartesian-axis-ticks">
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <line
                      className="recharts-cartesian-axis-tick-line"
                      width={60}
                      height={258}
                      x={0}
                      y={48}
                      stroke="rgba(1, 22, 39, 0.16)"
                      fill="none"
                      x1={4}
                      y1={306}
                      x2={60}
                      y2={306} />
                    <text
                      width={60}
                      height={258}
                      x={4}
                      y={306}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="start"
                    >
                      <tspan x={4} dy="0.355em">
                        0.00
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <line
                      className="recharts-cartesian-axis-tick-line"
                      width={60}
                      height={258}
                      x={0}
                      y={48}
                      stroke="rgba(1, 22, 39, 0.16)"
                      fill="none"
                      x1={4}
                      y1="241.5"
                      x2={60}
                      y2="241.5" />
                    <text
                      width={60}
                      height={258}
                      x={4}
                      y="241.5"
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="start"
                    >
                      <tspan x={4} dy="0.355em">
                        750.00
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <line
                      className="recharts-cartesian-axis-tick-line"
                      width={60}
                      height={258}
                      x={0}
                      y={48}
                      stroke="rgba(1, 22, 39, 0.16)"
                      fill="none"
                      x1={4}
                      y1={177}
                      x2={60}
                      y2={177} />
                    <text
                      width={60}
                      height={258}
                      x={4}
                      y={177}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="start"
                    >
                      <tspan x={4} dy="0.355em">
                        1.50k
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <line
                      className="recharts-cartesian-axis-tick-line"
                      width={60}
                      height={258}
                      x={0}
                      y={48}
                      stroke="rgba(1, 22, 39, 0.16)"
                      fill="none"
                      x1={4}
                      y1="112.5"
                      x2={60}
                      y2="112.5" />
                    <text
                      width={60}
                      height={258}
                      x={4}
                      y="112.5"
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="start"
                    >
                      <tspan x={4} dy="0.355em">
                        2.25k
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <line
                      className="recharts-cartesian-axis-tick-line"
                      width={60}
                      height={258}
                      x={0}
                      y={48}
                      stroke="rgba(1, 22, 39, 0.16)"
                      fill="none"
                      x1={4}
                      y1={48}
                      x2={60}
                      y2={48} />
                    <text
                      width={60}
                      height={258}
                      x={4}
                      y={48}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="start"
                    >
                      <tspan x={4} dy="0.355em">
                        3.00k
                      </tspan>
                    </text>
                  </g>
                </g>
                <text
                  fill="rgba(1, 22, 39, 0.32)"
                  x={5}
                  y={53}
                  className="recharts-text recharts-label"
                  textAnchor="start"
                >
                  <tspan x={5} dy="0.71em">
                    Gross revenue, USD
                  </tspan>
                </text>
              </g>
              <g className="recharts-layer recharts-cartesian-axis recharts-yAxis yAxis">
                <g className="recharts-cartesian-axis-ticks">
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <line
                      className="recharts-cartesian-axis-tick-line"
                      width={60}
                      height={258}
                      x={1316}
                      y={48}
                      stroke="rgba(1, 22, 39, 0.16)"
                      fill="none"
                      x1={1372}
                      y1={306}
                      x2={1316}
                      y2={306} />
                    <text
                      width={60}
                      height={258}
                      x={1373}
                      y={306}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="end"
                    >
                      <tspan x={1373} dy="0.355em">
                        0
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <line
                      className="recharts-cartesian-axis-tick-line"
                      width={60}
                      height={258}
                      x={1316}
                      y={48}
                      stroke="rgba(1, 22, 39, 0.16)"
                      fill="none"
                      x1={1372}
                      y1="241.5"
                      x2={1316}
                      y2="241.5" />
                    <text
                      width={60}
                      height={258}
                      x={1373}
                      y="241.5"
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="end"
                    >
                      <tspan x={1373} dy="0.355em">
                        15
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <line
                      className="recharts-cartesian-axis-tick-line"
                      width={60}
                      height={258}
                      x={1316}
                      y={48}
                      stroke="rgba(1, 22, 39, 0.16)"
                      fill="none"
                      x1={1372}
                      y1={177}
                      x2={1316}
                      y2={177} />
                    <text
                      width={60}
                      height={258}
                      x={1373}
                      y={177}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="end"
                    >
                      <tspan x={1373} dy="0.355em">
                        30
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <line
                      className="recharts-cartesian-axis-tick-line"
                      width={60}
                      height={258}
                      x={1316}
                      y={48}
                      stroke="rgba(1, 22, 39, 0.16)"
                      fill="none"
                      x1={1372}
                      y1="112.5"
                      x2={1316}
                      y2="112.5" />
                    <text
                      width={60}
                      height={258}
                      x={1373}
                      y="112.5"
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="end"
                    >
                      <tspan x={1373} dy="0.355em">
                        45
                      </tspan>
                    </text>
                  </g>
                  <g className="recharts-layer recharts-cartesian-axis-tick">
                    <line
                      className="recharts-cartesian-axis-tick-line"
                      width={60}
                      height={258}
                      x={1316}
                      y={48}
                      stroke="rgba(1, 22, 39, 0.16)"
                      fill="none"
                      x1={1372}
                      y1={48}
                      x2={1316}
                      y2={48} />
                    <text
                      width={60}
                      height={258}
                      x={1373}
                      y={48}
                      stroke="none"
                      fill="rgba(1, 22, 39, 0.32)"
                      className="recharts-text recharts-cartesian-axis-tick-value"
                      textAnchor="end"
                    >
                      <tspan x={1373} dy="0.355em">
                        60
                      </tspan>
                    </text>
                  </g>
                </g>
                <text
                  fill="rgba(1, 22, 39, 0.32)"
                  x={1371}
                  y={53}
                  className="recharts-text recharts-label"
                  textAnchor="end"
                >
                  <tspan x={1371} dy="0.71em">
                    Payments
                  </tspan>
                </text>
              </g>
              <g className="recharts-layer recharts-bar">
                <g className="recharts-layer recharts-bar-rectangles">
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="244.18152"
                      x={70}
                      y="61.818479999999994"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 70,61.818479999999994 h 20 v 244.18152 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="109.51326"
                      x="111.86666666666667"
                      y="196.48674"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 111.86666666666667,196.48674 h 20 v 109.51326 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="128.64224"
                      x="153.73333333333335"
                      y="177.35776"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 153.73333333333335,177.35776 h 20 v 128.64224 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="30.394979999999975"
                      x="195.6"
                      y="275.60502"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 195.6,275.60502 h 20 v 30.394979999999975 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="71.8014"
                      x="237.46666666666667"
                      y="234.1986"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 237.46666666666667,234.1986 h 20 v 71.8014 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="130.53853999999998"
                      x="279.33333333333337"
                      y="175.46146000000002"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 279.33333333333337,175.46146000000002 h 20 v 130.53853999999998 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="104.94837999999999"
                      x="321.2"
                      y="201.05162"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 321.2,201.05162 h 20 v 104.94837999999999 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="34.57457999999997"
                      x="363.06666666666666"
                      y="271.42542000000003"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 363.06666666666666,271.42542000000003 h 20 v 34.57457999999997 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="95.70767999999998"
                      x="404.93333333333334"
                      y="210.29232000000002"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 404.93333333333334,210.29232000000002 h 20 v 95.70767999999998 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="100.2029"
                      x="446.8"
                      y="205.7971"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 446.8,205.7971 h 20 v 100.2029 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="93.62304"
                      x="488.6666666666667"
                      y="212.37696"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 488.6666666666667,212.37696 h 20 v 93.62304 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="99.30248"
                      x="530.5333333333333"
                      y="206.69752"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 530.5333333333333,206.69752 h 20 v 99.30248 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="105.04384000000002"
                      x="572.4"
                      y="200.95615999999998"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 572.4,200.95615999999998 h 20 v 105.04384000000002 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="107.10612"
                      x="614.2666666666667"
                      y="198.89388"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 614.2666666666667,198.89388 h 20 v 107.10612 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="89.79604"
                      x="656.1333333333333"
                      y="216.20396"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 656.1333333333333,216.20396 h 20 v 89.79604 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="68.56006000000002"
                      x={698}
                      y="237.43993999999998"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 698,237.43993999999998 h 20 v 68.56006000000002 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="125.15838"
                      x="739.8666666666667"
                      y="180.84162"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 739.8666666666667,180.84162 h 20 v 125.15838 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="87.01222000000001"
                      x="781.7333333333333"
                      y="218.98778"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 781.7333333333333,218.98778 h 20 v 87.01222000000001 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="69.51982000000001"
                      x="823.6"
                      y="236.48018"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 823.6,236.48018 h 20 v 69.51982000000001 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="119.86078"
                      x="865.4666666666667"
                      y="186.13922"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 865.4666666666667,186.13922 h 20 v 119.86078 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="92.12664000000001"
                      x="907.3333333333334"
                      y="213.87336"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 907.3333333333334,213.87336 h 20 v 92.12664000000001 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="68.14898"
                      x="949.2"
                      y="237.85102"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 949.2,237.85102 h 20 v 68.14898 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="70.74360000000001"
                      x="991.0666666666667"
                      y="235.25639999999999"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 991.0666666666667,235.25639999999999 h 20 v 70.74360000000001 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="55.77874"
                      x="1032.9333333333334"
                      y="250.22126"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 1032.9333333333334,250.22126 h 20 v 55.77874 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="94.11496"
                      x="1074.8"
                      y="211.88504"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 1074.8,211.88504 h 20 v 94.11496 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="81.35342"
                      x="1116.6666666666667"
                      y="224.64658"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 1116.6666666666667,224.64658 h 20 v 81.35342 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="112.87414000000001"
                      x="1158.5333333333333"
                      y="193.12586"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 1158.5333333333333,193.12586 h 20 v 112.87414000000001 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="99.73334"
                      x="1200.4"
                      y="206.26666"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 1200.4,206.26666 h 20 v 99.73334 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="82.34843999999998"
                      x="1242.2666666666667"
                      y="223.65156000000002"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 1242.2666666666667,223.65156000000002 h 20 v 82.34843999999998 h -20 Z" />
                  </g>
                  <g className="recharts-layer recharts-bar-rectangle">
                    <path
                      fill="#0076ff"
                      opacity="0.8"
                      width={20}
                      height="76.90377999999998"
                      x="1284.1333333333334"
                      y="229.09622000000002"
                      radius={0}
                      className="recharts-rectangle"
                      d="M 1284.1333333333334,229.09622000000002 h 20 v 76.90377999999998 h -20 Z" />
                  </g>
                </g>
              </g>
              <g className="recharts-layer recharts-line">
                <path
                  stroke="#00c77e"
                  strokeWidth={2}
                  fill="none"
                  width={1256}
                  height={258}
                  className="recharts-curve recharts-line-curve"
                  d="M80.93333333333334,121.1L122.80000000000001,202.8L164.66666666666669,202.8L206.53333333333333,284.5L248.4,275.9L290.2666666666667,202.8L332.1333333333333,215.7L374,271.6L415.8666666666667,220L457.73333333333335,220L499.6,220L541.4666666666666,220L583.3333333333333,215.7L625.1999999999999,220L667.0666666666666,228.60000000000002L708.9333333333333,250.1L750.8,189.89999999999998L792.6666666666666,232.9L834.5333333333333,245.8L876.4,211.4L918.2666666666667,224.3L960.1333333333333,250.1L1002,245.8L1043.8666666666668,254.4L1085.7333333333333,228.60000000000002L1127.6000000000001,232.9L1169.4666666666667,215.7L1211.3333333333335,220L1253.2,237.2L1295.0666666666668,245.8" />
              </g>
            </svg>
            <div
              className="recharts-legend-wrapper"
              style={{
                position: "absolute",
                width: 800,
                height: "auto",
                left: 0,
                top: 0,
              }}
            >
              <ul className="balance-chart__chart__legend">
                <li className="balance-chart__chart__legend__item">
                  <div
                    className="balance-chart__chart__legend__item__marker"
                    style={{ backgroundColor: "rgb(0, 199, 126)" }} />
                  Payments
                </li>
                <li className="balance-chart__chart__legend__item">
                  <div
                    className="balance-chart__chart__legend__item__marker"
                    style={{ backgroundColor: "rgb(0, 118, 255)" }} />
                  Gross revenue
                </li>
              </ul>
            </div>
            <div
              className="recharts-tooltip-wrapper recharts-tooltip-wrapper-right recharts-tooltip-wrapper-bottom"
              style={{
                pointerEvents: "none",
                visibility: "hidden",
                position: "absolute",
                top: 0,
                transform: "translate(1137.6px, 70px)",
              }}
            >
              <div className="balance-chart__chart__tooltip">
                <div className="balance-chart__chart__tooltip__title" />
              </div>
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              width: 0,
              height: 0,
              visibility: "hidden",
              display: "none",
            }} />
        </div>
      </div>

    </div>
  );
}

export function PAlogin0fake() {
  return (
    <FormGroup indentation="lg">
      <PAchartUsersMethods />
    </FormGroup>
  );
}

export function PAlogin0fake1() {
  return (
    <FormGroup indentation="lg">
      <svg
        version="1.1"
        className="highcharts-root"
        xmlns="http://www.w3.org/2000/svg"
        width={1376}
        height={422}
        viewBox="0 0 1376 422"
      >
        <desc>Created with Highcharts 7.1.1</desc>
        <defs>
          <clipPath id="highcharts-oy9rxvt-152-">
            <rect x={0} y={0} width={1376} height={377} />
          </clipPath>
          <filter id="drop-shadow-10" opacity="0.5">
            <feGaussianBlur in="SourceAlpha" stdDeviation={1} />
            <feOffset dx={1} dy={1} />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.3" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <style
            dangerouslySetInnerHTML={{
              __html: ".highcharts-tooltip-10{filter:url(#drop-shadow-10)}",
            }} />
        </defs>
        <rect
          className="highcharts-background"
          x="0.5"
          y="0.5"
          width={1374}
          height={420}
          rx={0}
          ry={0} />
        <rect
          className="highcharts-plot-background"
          x={0}
          y={25}
          width={1376}
          height={377} />
        <rect
          className="highcharts-plot-border"
          data-z-index={1}
          x="-0.5"
          y="24.5"
          width={1377}
          height={378} />
        <g className="highcharts-grid highcharts-xaxis-grid" data-z-index={1}>
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 34.5 25 L 34.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 70.5 25 L 70.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 105.5 25 L 105.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 140.5 25 L 140.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 175.5 25 L 175.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 211.5 25 L 211.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 246.5 25 L 246.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 281.5 25 L 281.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 317.5 25 L 317.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 352.5 25 L 352.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 387.5 25 L 387.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 422.5 25 L 422.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 458.5 25 L 458.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 493.5 25 L 493.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 528.5 25 L 528.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 564.5 25 L 564.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 599.5 25 L 599.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 634.5 25 L 634.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 669.5 25 L 669.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 705.5 25 L 705.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 740.5 25 L 740.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 775.5 25 L 775.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 810.5 25 L 810.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 846.5 25 L 846.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 881.5 25 L 881.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 916.5 25 L 916.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 952.5 25 L 952.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 987.5 25 L 987.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1022.5 25 L 1022.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1057.5 25 L 1057.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1093.5 25 L 1093.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1128.5 25 L 1128.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1163.5 25 L 1163.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1199.5 25 L 1199.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1234.5 25 L 1234.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1269.5 25 L 1269.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1304.5 25 L 1304.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1340.5 25 L 1340.5 402"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1375.5 25 L 1375.5 402"
            opacity={1} />
        </g>
        <g className="highcharts-grid highcharts-yaxis-grid" data-z-index={1}>
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 402.5 L 1376 402.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 339.5 L 1376 339.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 276.5 L 1376 276.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 214.5 L 1376 214.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 151.5 L 1376 151.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 88.5 L 1376 88.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 24.5 L 1376 24.5"
            opacity={1} />
        </g>
        <g className="highcharts-axis highcharts-xaxis" data-z-index={2}>
          <path className="highcharts-axis-line" d="M 0 402.5 L 1376 402.5" />
        </g>
        <g className="highcharts-axis highcharts-yaxis" data-z-index={2}>
          <path className="highcharts-axis-line" d="M 20 25 L 20 402" />
          <text
            x={0}
            data-z-index={7}
            textAnchor="start"
            transform="translate(0,0)"
            className="highcharts-axis-title"
            y={19}
          >
            <tspan>Daily active users</tspan>
          </text>
        </g>
        <path
          className="highcharts-crosshair highcharts-crosshair-category undefined"
          data-z-index={2}
          visibility="visible"
          d="M 405.5 25 L 405.5 402" />
        <g className="highcharts-series-group" data-z-index={3}>
          <g
            data-z-index="0.1"
            className="highcharts-series highcharts-series-0 highcharts-line-series highcharts-color-1    highcharts-series-hover"
            transform="translate(0,25) scale(1 1)"
            clipPath="url(#highcharts-oy9rxvt-152-)"
          >
            <path
              d="M 88.205128205128 366.94666666666666 L 123.48717948718 366.3183333333333 L 158.76923076923 163.36666666666667 L 194.05128205128 114.35666666666668 L 229.33333333333 77.28500000000003 L 264.61538461538 157.71166666666667 L 299.89743589744 163.995 L 335.17948717949 172.16333333333336 L 370.46153846154 157.08333333333334 L 405.74358974359 169.02166666666668 L 441.02564102564 145.145 L 476.30769230769 185.35833333333335 L 511.58974358974 156.455 L 546.87179487179 96.76333333333332 L 582.15384615385 35.815 L 617.4358974359 47.75333333333333 L 652.71794871795 138.23333333333335 L 688 148.91500000000002 L 723.28205128205 133.835 L 758.5641025641 150.8 L 793.84615384615 211.12 L 829.12820512821 202.32333333333335 L 864.41025641026 194.78333333333333 L 899.69230769231 177.19 L 934.97435897436 169.65 L 970.25641025641 75.40000000000003 L 1005.5384615385 143.88833333333335 L 1040.8205128205 105.56 L 1076.1025641026 127.55166666666668 L 1111.3846153846 87.33833333333337 L 1146.6666666667 128.80833333333334 L 1181.9487179487 91.73666666666668 L 1217.2307692308 128.18 L 1252.5128205128 99.90500000000003 L 1287.7948717949 101.79000000000002 L 1323.0769230769 89.22333333333336"
              className="highcharts-graph"
              data-z-index={1} />
            <path
              d="M 78.205128205128 366.94666666666666 L 88.205128205128 366.94666666666666 L 123.48717948718 366.3183333333333 L 158.76923076923 163.36666666666667 L 194.05128205128 114.35666666666668 L 229.33333333333 77.28500000000003 L 264.61538461538 157.71166666666667 L 299.89743589744 163.995 L 335.17948717949 172.16333333333336 L 370.46153846154 157.08333333333334 L 405.74358974359 169.02166666666668 L 441.02564102564 145.145 L 476.30769230769 185.35833333333335 L 511.58974358974 156.455 L 546.87179487179 96.76333333333332 L 582.15384615385 35.815 L 617.4358974359 47.75333333333333 L 652.71794871795 138.23333333333335 L 688 148.91500000000002 L 723.28205128205 133.835 L 758.5641025641 150.8 L 793.84615384615 211.12 L 829.12820512821 202.32333333333335 L 864.41025641026 194.78333333333333 L 899.69230769231 177.19 L 934.97435897436 169.65 L 970.25641025641 75.40000000000003 L 1005.5384615385 143.88833333333335 L 1040.8205128205 105.56 L 1076.1025641026 127.55166666666668 L 1111.3846153846 87.33833333333337 L 1146.6666666667 128.80833333333334 L 1181.9487179487 91.73666666666668 L 1217.2307692308 128.18 L 1252.5128205128 99.90500000000003 L 1287.7948717949 101.79000000000002 L 1323.0769230769 89.22333333333336 L 1333.0769230769 89.22333333333336"
              visibility="visible"
              data-z-index={2}
              className="highcharts-tracker-line" />
          </g>
          <g
            data-z-index="0.1"
            className="highcharts-markers highcharts-series-0 highcharts-line-series highcharts-color-1  highcharts-tracker   highcharts-series-hover"
            transform="translate(0,25) scale(1 1)"
          >
            <path
              visibility="visible"
              d="M 405 179.02166666666668 A 10 10 0 1 1 405.00999999833334 179.0216616666671 Z"
              className="highcharts-halo highcharts-color-1"
              data-z-index={-1} />
            <path
              d="M 88 371 A 4 4 0 1 1 88.00399999933333 370.9999980000002 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 123 370 A 4 4 0 1 1 123.00399999933333 369.9999980000002 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 158 167 A 4 4 0 1 1 158.00399999933333 166.99999800000018 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 194 118 A 4 4 0 1 1 194.00399999933333 117.99999800000016 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 229 81 A 4 4 0 1 1 229.00399999933333 80.99999800000016 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 264 162 A 4 4 0 1 1 264.00399999933336 161.99999800000018 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 299 167.995 A 4 4 0 1 1 299.00399999933336 167.99499800000018 Z"
              className="highcharts-point highcharts-color-1 " />
            <path
              d="M 335 176.16333333333336 A 4 4 0 1 1 335.00399999933336 176.16333133333353 Z"
              className="highcharts-point highcharts-color-1  " />
            <path
              d="M 370 161.08333333333334 A 4 4 0 1 1 370.00399999933336 161.08333133333352 Z"
              className="highcharts-point highcharts-color-1  " />
            <path
              d="M 405 175.02166666666668 A 6 6 0 1 1 405.005999999 175.02166366666694 Z"
              className="highcharts-point highcharts-color-1  highcharts-point-hover" />
            <path
              d="M 441 149.145 A 4 4 0 1 1 441.00399999933336 149.1449980000002 Z"
              className="highcharts-point highcharts-color-1  " />
            <path
              d="M 476 189.35833333333335 A 4 4 0 1 1 476.00399999933336 189.35833133333352 Z"
              className="highcharts-point highcharts-color-1  " />
            <path
              d="M 511 160 A 4 4 0 1 1 511.00399999933336 159.99999800000018 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 546 100.76333333333332 A 4 4 0 1 1 546.0039999993334 100.76333133333348 Z"
              className="highcharts-point highcharts-color-1 " />
            <path
              d="M 582 40 A 4 4 0 1 1 582.0039999993334 39.99999800000017 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 617 52 A 4 4 0 1 1 617.0039999993334 51.99999800000017 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 652 142.23333333333335 A 4 4 0 1 1 652.0039999993334 142.23333133333352 Z"
              className="highcharts-point highcharts-color-1 " />
            <path
              d="M 688 153 A 4 4 0 1 1 688.0039999993334 152.99999800000018 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 723 138 A 4 4 0 1 1 723.0039999993334 137.99999800000018 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 758 154.8 A 4 4 0 1 1 758.0039999993334 154.7999980000002 Z"
              className="highcharts-point highcharts-color-1 " />
            <path
              d="M 793 215 A 4 4 0 1 1 793.0039999993334 214.99999800000018 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 829 206 A 4 4 0 1 1 829.0039999993334 205.99999800000018 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 864 198.78333333333333 A 4 4 0 1 1 864.0039999993334 198.7833313333335 Z"
              className="highcharts-point highcharts-color-1  " />
            <path
              d="M 899 181 A 4 4 0 1 1 899.0039999993334 180.99999800000018 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 934 174 A 4 4 0 1 1 934.0039999993334 173.99999800000018 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 970 79 A 4 4 0 1 1 970.0039999993334 78.99999800000016 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 1005 147.88833333333335 A 4 4 0 1 1 1005.0039999993334 147.88833133333353 Z"
              className="highcharts-point highcharts-color-1 " />
            <path
              d="M 1040 110 A 4 4 0 1 1 1040.0039999993332 109.99999800000016 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 1076 131.55166666666668 A 4 4 0 1 1 1076.0039999993332 131.55166466666685 Z"
              className="highcharts-point highcharts-color-1 " />
            <path
              d="M 1111 91.33833333333337 A 4 4 0 1 1 1111.0039999993332 91.33833133333353 Z"
              className="highcharts-point highcharts-color-1 " />
            <path
              d="M 1146 133 A 4 4 0 1 1 1146.0039999993332 132.99999800000018 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 1181 95.73666666666668 A 4 4 0 1 1 1181.0039999993332 95.73666466666684 Z"
              className="highcharts-point highcharts-color-1  " />
            <path
              d="M 1217 132.18 A 4 4 0 1 1 1217.0039999993332 132.17999800000018 Z"
              className="highcharts-point highcharts-color-1 " />
            <path
              d="M 1252 103.90500000000003 A 4 4 0 1 1 1252.0039999993332 103.90499800000019 Z"
              className="highcharts-point highcharts-color-1  " />
            <path
              d="M 1287 106 A 4 4 0 1 1 1287.0039999993332 105.99999800000016 Z"
              className="highcharts-point highcharts-color-1" />
            <path
              d="M 1323 93.22333333333336 A 4 4 0 1 1 1323.0039999993332 93.22333133333352 Z"
              className="highcharts-point highcharts-color-1  " />
          </g>
        </g>
        <text
          x={688}
          textAnchor="middle"
          className="highcharts-title"
          data-z-index={4}
          y={14} />
        <text
          x={688}
          textAnchor="middle"
          className="highcharts-subtitle"
          data-z-index={4}
          y={14} />
        <g
          className="highcharts-axis-labels highcharts-xaxis-labels"
          data-z-index={7}
        >
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            -2
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            -1
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            6/30/19
          </text>
          <text
            x="123.48717948718436"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            7/1/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/2/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/3/19
          </text>
          <text
            x="229.33333333333437"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            7/4/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/5/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/6/19
          </text>
          <text
            x="335.17948717948434"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            7/7/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/8/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/9/19
          </text>
          <text
            x="441.02564102564435"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            7/10/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/11/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/12/19
          </text>
          <text
            x="546.8717948717944"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            7/13/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/14/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/15/19
          </text>
          <text
            x="652.7179487179444"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            7/16/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/17/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/18/19
          </text>
          <text
            x="758.5641025641044"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            7/19/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/20/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/21/19
          </text>
          <text
            x="864.4102564102544"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            7/22/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/23/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/24/19
          </text>
          <text
            x="970.2564102564144"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            7/25/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/26/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/27/19
          </text>
          <text
            x="1076.1025641025744"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            7/28/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/29/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            7/30/19
          </text>
          <text
            x="1181.9487179486744"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            7/31/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            8/1/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            8/2/19
          </text>
          <text
            x="1287.7948717948743"
            textAnchor="middle"
            transform="translate(0,0)"
            y={420}
            opacity={1}
          >
            8/3/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            8/4/19
          </text>
          <text x={0} textAnchor="middle" transform="translate(0,0)" y={-9999}>
            36
          </text>
        </g>
        <g
          className="highcharts-axis-labels highcharts-yaxis-labels"
          data-z-index={7}
        >
          <text x={0} textAnchor="start" transform="translate(0,0)" y={-9999}>
            0
          </text>
          <text
            x={5}
            textAnchor="start"
            transform="translate(0,0)"
            y={333}
            opacity={1}
          >
            100
          </text>
          <text
            x={5}
            textAnchor="start"
            transform="translate(0,0)"
            y={270}
            opacity={1}
          >
            200
          </text>
          <text
            x={5}
            textAnchor="start"
            transform="translate(0,0)"
            y={208}
            opacity={1}
          >
            300
          </text>
          <text
            x={5}
            textAnchor="start"
            transform="translate(0,0)"
            y={145}
            opacity={1}
          >
            400
          </text>
          <text
            x={5}
            textAnchor="start"
            transform="translate(0,0)"
            y={82}
            opacity={1}
          >
            500
          </text>
          <text x={0} textAnchor="start" transform="translate(0,0)" y={-9999}>
            600
          </text>
        </g>
        <g
          className="highcharts-label highcharts-tooltip highcharts-tooltip-10                           highcharts-color-1"
          data-z-index={8}
          transform="translate(297,106)"
          opacity={1}
          visibility="visible"
        >
          <path
            className="highcharts-label-box highcharts-tooltip-box"
            d="M 4.5 0.5 L 214.5 0.5 C 218.5 0.5 218.5 0.5 218.5 4.5 L 218.5 68.5 C 218.5 72.5 218.5 72.5 214.5 72.5 L 4.5 72.5 C 0.5 72.5 0.5 72.5 0.5 68.5 L 0.5 4.5 C 0.5 0.5 0.5 0.5 4.5 0.5" />
        </g>
      </svg>
    </FormGroup>
  );
}

export function PAloginSocialfake() {
  return (
    <FormGroup indentation="lg">
      <svg
        version="1.1"
        className="highcharts-root"
        xmlns="http://www.w3.org/2000/svg"
        width={1376}
        height={400}
        viewBox="0 0 1376 400"
      >
        <desc>Created with Highcharts 7.1.1</desc>
        <defs>
          <clipPath id="highcharts-oy9rxvt-192-">
            <rect x={0} y={0} width={1376} height={354} />
          </clipPath>
          <filter id="drop-shadow-11" opacity="0.5">
            <feGaussianBlur in="SourceAlpha" stdDeviation={1} />
            <feOffset dx={1} dy={1} />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.3" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <style
            dangerouslySetInnerHTML={{
              __html: ".highcharts-tooltip-11{filter:url(#drop-shadow-11)}",
            }} />
        </defs>
        <rect
          className="highcharts-background"
          x="0.5"
          y="0.5"
          width={1374}
          height={398}
          rx={0}
          ry={0} />
        <rect
          className="highcharts-plot-background"
          x={0}
          y={25}
          width={1376}
          height={354} />
        <rect
          className="highcharts-plot-border"
          data-z-index={1}
          x="-0.5"
          y="24.5"
          width={1377}
          height={355} />
        <g className="highcharts-grid highcharts-xaxis-grid" data-z-index={1}>
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 228.5 25 L 228.5 379"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 458.5 25 L 458.5 379"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 687.5 25 L 687.5 379"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 916.5 25 L 916.5 379"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1146.5 25 L 1146.5 379"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 1375.5 25 L 1375.5 379"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M -0.5 25 L -0.5 379"
            opacity={1} />
        </g>
        <g className="highcharts-grid highcharts-yaxis-grid" data-z-index={1}>
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 379.5 L 1376 379.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 320.5 L 1376 320.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 261.5 L 1376 261.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 202.5 L 1376 202.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 143.5 L 1376 143.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 84.5 L 1376 84.5"
            opacity={1} />
          <path
            data-z-index={1}
            className="highcharts-grid-line"
            d="M 0 24.5 L 1376 24.5"
            opacity={1} />
        </g>
        <g className="highcharts-axis highcharts-xaxis" data-z-index={2}>
          <path className="highcharts-axis-line" d="M 0 379.5 L 1376 379.5" />
        </g>
        <g className="highcharts-axis highcharts-yaxis" data-z-index={2}>
          <path className="highcharts-axis-line" d="M 20 25 L 20 379" />
          <text
            x={0}
            data-z-index={7}
            textAnchor="start"
            transform="translate(0,0)"
            className="highcharts-axis-title"
            y={19}
          >
            <tspan>Number of authentications</tspan>
          </text>
        </g>
        <path
          className="highcharts-crosshair highcharts-crosshair-category undefined"
          data-z-index={2}
          visibility="hidden"
          d="M 802.5 25 L 802.5 379" />
        <g className="highcharts-series-group" data-z-index={3}>
          <g
            data-z-index="0.1"
            className="highcharts-series highcharts-series-0 highcharts-column-series highcharts-color-0  highcharts-tracker   "
            transform="translate(0,25) scale(1 1)"
            clipPath="url(#highcharts-oy9rxvt-192-)"
          >
            <rect
              x="78.5"
              y="66.5"
              width={72}
              height={288}
              className="highcharts-point highcharts-color-0" />
            <rect
              x="307.5"
              y="115.5"
              width={72}
              height={239}
              className="highcharts-point highcharts-color-0" />
            <rect
              x="536.5"
              y="246.5"
              width={72}
              height={108}
              className="highcharts-point highcharts-color-0 " />
            <rect
              x="766.5"
              y="312.5"
              width={72}
              height={42}
              className="highcharts-point highcharts-color-0  " />
            <rect
              x="995.5"
              y="333.5"
              width={72}
              height={21}
              className="highcharts-point highcharts-color-0 " />
            <rect
              x="1224.5"
              y="349.5"
              width={72}
              height={5}
              className="highcharts-point highcharts-color-0 " />
          </g>
          <g
            data-z-index="0.1"
            className="highcharts-markers highcharts-series-0 highcharts-column-series highcharts-color-0    "
            transform="translate(0,25) scale(1 1)"
            clipPath="none" />
        </g>
        <text
          x={688}
          textAnchor="middle"
          className="highcharts-title"
          data-z-index={4}
          y={14} />
        <text
          x={688}
          textAnchor="middle"
          className="highcharts-subtitle"
          data-z-index={4}
          y={14} />
        <g
          className="highcharts-stack-labels"
          visibility="visible"
          data-z-index={6}
          transform="translate(0,25)"
        >
          <text
            x={0}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            visibility="hidden"
            transform="translate(0,0)"
            y={0}
          >
            <tspan
              x={0}
              y={0}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              0
            </tspan>
            <tspan x={0} y={0}>
              0
            </tspan>
          </text>
          <text
            x={0}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            visibility="hidden"
            transform="translate(0,0)"
            y={0}
            opacity={0}
          >
            <tspan
              x={0}
              y={0}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              0
            </tspan>
            <tspan x={0} y={0}>
              0
            </tspan>
          </text>
          <text
            x={0}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            visibility="hidden"
            transform="translate(0,0)"
            y={0}
            opacity={0}
          >
            <tspan
              x={0}
              y={0}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              0
            </tspan>
            <tspan x={0} y={0}>
              0
            </tspan>
          </text>
          <text
            x={0}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            visibility="hidden"
            transform="translate(0,0)"
            y={0}
            opacity={0}
          >
            <tspan
              x={0}
              y={0}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              0
            </tspan>
            <tspan x={0} y={0}>
              0
            </tspan>
          </text>
          <text
            x={0}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            visibility="hidden"
            transform="translate(0,0)"
            y={0}
            opacity={0}
          >
            <tspan
              x={0}
              y={0}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              0
            </tspan>
            <tspan x={0} y={0}>
              0
            </tspan>
          </text>
          <text
            x={0}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            visibility="hidden"
            transform="translate(0,0)"
            y={0}
            opacity={0}
          >
            <tspan
              x={0}
              y={0}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              0
            </tspan>
            <tspan x={0} y={0}>
              0
            </tspan>
          </text>
          <text
            x={115}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            transform="translate(0,0)"
            y={60}
          >
            <tspan
              x={115}
              y={60}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              12,218
            </tspan>
            <tspan x={115} y={60}>
              12,218
            </tspan>
          </text>
          <text
            x={344}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            transform="translate(0,0)"
            y={109}
          >
            <tspan
              x={344}
              y={109}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              10,136
            </tspan>
            <tspan x={344} y={109}>
              10,136
            </tspan>
          </text>
          <text
            x={573}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            transform="translate(0,0)"
            y={240}
          >
            <tspan
              x={573}
              y={240}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              4,559
            </tspan>
            <tspan x={573} y={240}>
              4,559
            </tspan>
          </text>
          <text
            x={803}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            transform="translate(0,0)"
            y={306}
          >
            <tspan
              x={803}
              y={306}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              1,788
            </tspan>
            <tspan x={803} y={306}>
              1,788
            </tspan>
          </text>
          <text
            x={1032}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            transform="translate(0,0)"
            y={327}
          >
            <tspan
              x={1032}
              y={327}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              903
            </tspan>
            <tspan x={1032} y={327}>
              903
            </tspan>
          </text>
          <text
            x={1261}
            style={{
              color: "#000000",
              fontSize: 11,
              fontWeight: "bold",
              fill: "#000000",
            }}
            textAnchor="middle"
            transform="translate(0,0)"
            y={343}
          >
            <tspan
              x={1261}
              y={343}
              className="highcharts-text-outline"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="2px"
              strokeLinejoin="round"
            >
              193
            </tspan>
            <tspan x={1261} y={343}>
              193
            </tspan>
          </text>
        </g>
        <g
          className="highcharts-axis-labels highcharts-xaxis-labels"
          data-z-index={7}
        >
          <text
            x="114.66666666666332"
            textAnchor="middle"
            transform="translate(0,0)"
            y={397}
            opacity={1}
          >
            <tspan className="highcharts-strong">Facebook</tspan>
          </text>
          <text
            x="344.0000000000033"
            textAnchor="middle"
            transform="translate(0,0)"
            y={397}
            opacity={1}
          >
            <tspan className="highcharts-strong">Google</tspan>
          </text>
          <text
            x="573.3333333333334"
            textAnchor="middle"
            transform="translate(0,0)"
            y={397}
            opacity={1}
          >
            <tspan className="highcharts-strong">Email/Password</tspan>
          </text>
          <text
            x="802.6666666666633"
            textAnchor="middle"
            transform="translate(0,0)"
            y={397}
            opacity={1}
          >
            <tspan className="highcharts-strong">Discord</tspan>
          </text>
          <text
            x="1032.0000000000332"
            textAnchor="middle"
            transform="translate(0,0)"
            y={397}
            opacity={1}
          >
            <tspan className="highcharts-strong">Twitch</tspan>
          </text>
          <text
            x="1261.3333333333333"
            textAnchor="middle"
            transform="translate(0,0)"
            y={397}
            opacity={1}
          >
            <tspan className="highcharts-strong">Other</tspan>
          </text>
        </g>
        <g
          className="highcharts-axis-labels highcharts-yaxis-labels"
          data-z-index={7}
        >
          <text x={0} textAnchor="start" transform="translate(0,0)" y={-9999}>
            0
          </text>
          <text
            x={5}
            textAnchor="start"
            transform="translate(0,0)"
            y={314}
            opacity={1}
          >
            2.5k
          </text>
          <text
            x={5}
            textAnchor="start"
            transform="translate(0,0)"
            y={255}
            opacity={1}
          >
            5k
          </text>
          <text
            x={5}
            textAnchor="start"
            transform="translate(0,0)"
            y={196}
            opacity={1}
          >
            7.5k
          </text>
          <text
            x={5}
            textAnchor="start"
            transform="translate(0,0)"
            y={137}
            opacity={1}
          >
            10k
          </text>
          <text
            x={5}
            textAnchor="start"
            transform="translate(0,0)"
            y={78}
            opacity={1}
          >
            12.5k
          </text>
          <text x={0} textAnchor="start" transform="translate(0,0)" y={-9999}>
            15k
          </text>
        </g>
        <g
          className="highcharts-label highcharts-tooltip highcharts-tooltip-11     highcharts-color-0"
          data-z-index={8}
          transform="translate(692,-9999)"
          opacity={0}
          visibility="visible"
        >
          <path
            className="highcharts-label-box highcharts-tooltip-box"
            d="M 4.5 0.5 L 218.5 0.5 C 222.5 0.5 222.5 0.5 222.5 4.5 L 222.5 88.5 C 222.5 92.5 222.5 92.5 218.5 92.5 L 4.5 92.5 C 0.5 92.5 0.5 92.5 0.5 88.5 L 0.5 4.5 C 0.5 0.5 0.5 0.5 4.5 0.5" />
        </g>
      </svg>
    </FormGroup>
  );
}

export function PAchart1fake() {
  return (
    <FormGroup indentation="lg">
      <div className="xsui-content-block__entry">
        <div className="xsui-head xsui-head--appearance-primary xsui-head--indentation-lg xsui-head--align-left">
          <div className="xsui-head__title"> Active users</div>
        </div>
        <div className="login-chart">
          <div data-highcharts-chart={0}>
            <div
              id="highcharts-dq774xd-0"
              dir="ltr"
              className="highcharts-container "
              style={{ overflow: "hidden" }}
            >
              <svg
                version="1.1"
                className="highcharts-root"
                xmlns="http://www.w3.org/2000/svg"
                width={1153}
                height={422}
                viewBox="0 0 1153 422"
              >
                <desc>Created with Highcharts 7.1.1</desc>
                <defs>
                  <clipPath id="highcharts-dq774xd-1-">
                    <rect x={0} y={0} width={1153} height={376} />
                  </clipPath>
                  <filter id="drop-shadow-0" opacity="0.5">
                    <feGaussianBlur in="SourceAlpha" stdDeviation={1} />
                    <feOffset dx={1} dy={1} />
                    <feComponentTransfer>
                      <feFuncA type="linear" slope="0.3" />
                    </feComponentTransfer>
                    <feMerge>
                      <feMergeNode />
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                  <style
                    dangerouslySetInnerHTML={{
                      __html: ".highcharts-tooltip-0{filter:url(#drop-shadow-0)}",
                    }} />
                </defs>
                <rect
                  className="highcharts-background"
                  x="0.5"
                  y="0.5"
                  width={1151}
                  height={420}
                  rx={0}
                  ry={0} />
                <rect
                  className="highcharts-plot-background"
                  x={0}
                  y={25}
                  width={1153}
                  height={376} />
                <rect
                  className="highcharts-plot-border"
                  data-z-index={1}
                  x="-0.5"
                  y="24.5"
                  width={1154}
                  height={377} />
                <g
                  className="highcharts-grid highcharts-xaxis-grid"
                  data-z-index={1}
                >
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 164.5 25 L 164.5 401"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 328.5 25 L 328.5 401"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 493.5 25 L 493.5 401"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 658.5 25 L 658.5 401"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 823.5 25 L 823.5 401"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 987.5 25 L 987.5 401"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 1152.5 25 L 1152.5 401"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M -0.5 25 L -0.5 401"
                    opacity={1} />
                </g>
                <g
                  className="highcharts-grid highcharts-yaxis-grid"
                  data-z-index={1}
                >
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 0 401.5 L 1153 401.5"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 0 326.5 L 1153 326.5"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 0 251.5 L 1153 251.5"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 0 175.5 L 1153 175.5"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 0 100.5 L 1153 100.5"
                    opacity={1} />
                  <path
                    data-z-index={1}
                    className="highcharts-grid-line"
                    d="M 0 24.5 L 1153 24.5"
                    opacity={1} />
                </g>
                <g
                  className="highcharts-axis highcharts-xaxis"
                  data-z-index={2}
                >
                  <path
                    className="highcharts-axis-line"
                    d="M 0 401.5 L 1153 401.5" />
                </g>
                <g
                  className="highcharts-axis highcharts-yaxis"
                  data-z-index={2}
                >
                  <path className="highcharts-axis-line" d="M 20 25 L 20 401" />
                  <text
                    x={0}
                    data-z-index={7}
                    textAnchor="start"
                    transform="translate(0,0)"
                    className="highcharts-axis-title"
                    y={19}
                  >
                    <tspan>Daily active users</tspan>
                  </text>
                </g>
                <g className="highcharts-series-group" data-z-index={3}>
                  <g
                    data-z-index="0.1"
                    className="highcharts-series highcharts-series-0 highcharts-line-series highcharts-color-1 "
                    transform="translate(0,25) scale(1 1)"
                    clipPath="url(#highcharts-dq774xd-1-)"
                  >
                    <path
                      d="M 82.357142857143 218.08 L 247.07142857143 282 L 411.78571428571 300.8 L 576.5 60.160000000000025 L 741.21428571429 146.64000000000001 L 905.92857142857 105.28000000000003 L 1070.6428571429 199.28"
                      className="highcharts-graph"
                      data-z-index={1} />
                    <path
                      d="M 72.357142857143 218.08 L 82.357142857143 218.08 L 247.07142857143 282 L 411.78571428571 300.8 L 576.5 60.160000000000025 L 741.21428571429 146.64000000000001 L 905.92857142857 105.28000000000003 L 1070.6428571429 199.28 L 1080.6428571429 199.28"
                      visibility="visible"
                      data-z-index={2}
                      className="highcharts-tracker-line" />
                  </g>
                  <g
                    data-z-index="0.1"
                    className="highcharts-markers highcharts-series-0 highcharts-line-series highcharts-color-1  highcharts-tracker"
                    transform="translate(0,25) scale(1 1)"
                    clipPath="none"
                  >
                    <path
                      d="M 82 222.08 A 4 4 0 1 1 82.00399999933333 222.0799980000002 Z"
                      className="highcharts-point highcharts-color-1" />
                    <path
                      d="M 247 286 A 4 4 0 1 1 247.00399999933333 285.9999980000002 Z"
                      className="highcharts-point highcharts-color-1" />
                    <path
                      d="M 411 304.8 A 4 4 0 1 1 411.00399999933336 304.7999980000002 Z"
                      className="highcharts-point highcharts-color-1" />
                    <path
                      d="M 576 64.16000000000003 A 4 4 0 1 1 576.0039999993334 64.15999800000019 Z"
                      className="highcharts-point highcharts-color-1" />
                    <path
                      d="M 741 150.64000000000001 A 4 4 0 1 1 741.0039999993334 150.6399980000002 Z"
                      className="highcharts-point highcharts-color-1" />
                    <path
                      d="M 905 109.28000000000003 A 4 4 0 1 1 905.0039999993334 109.27999800000019 Z"
                      className="highcharts-point highcharts-color-1" />
                    <path
                      d="M 1070 203.28 A 4 4 0 1 1 1070.0039999993332 203.27999800000018 Z"
                      className="highcharts-point highcharts-color-1" />
                  </g>
                </g>
                <text
                  x={577}
                  textAnchor="middle"
                  className="highcharts-title"
                  data-z-index={4}
                  y={14} />
                <text
                  x={577}
                  textAnchor="middle"
                  className="highcharts-subtitle"
                  data-z-index={4}
                  y={14} />
                <g
                  className="highcharts-axis-labels highcharts-xaxis-labels"
                  data-z-index={7}
                >
                  <text
                    x="82.35714285714715"
                    textAnchor="middle"
                    transform="translate(0,0)"
                    y={419}
                    opacity={1}
                  >
                    7/18/19
                  </text>
                  <text
                    x="247.07142857142716"
                    textAnchor="middle"
                    transform="translate(0,0)"
                    y={419}
                    opacity={1}
                  >
                    7/19/19
                  </text>
                  <text
                    x="411.7857142857172"
                    textAnchor="middle"
                    transform="translate(0,0)"
                    y={419}
                    opacity={1}
                  >
                    7/20/19
                  </text>
                  <text
                    x="576.4999999999972"
                    textAnchor="middle"
                    transform="translate(0,0)"
                    y={419}
                    opacity={1}
                  >
                    7/21/19
                  </text>
                  <text
                    x="741.2142857142871"
                    textAnchor="middle"
                    transform="translate(0,0)"
                    y={419}
                    opacity={1}
                  >
                    7/22/19
                  </text>
                  <text
                    x="905.9285714285671"
                    textAnchor="middle"
                    transform="translate(0,0)"
                    y={419}
                    opacity={1}
                  >
                    7/23/19
                  </text>
                  <text
                    x="1070.642857142857"
                    textAnchor="middle"
                    transform="translate(0,0)"
                    y={419}
                    opacity={1}
                  >
                    7/24/19
                  </text>
                </g>
                <g
                  className="highcharts-axis-labels highcharts-yaxis-labels"
                  data-z-index={7}
                >
                  <text
                    x={0}
                    textAnchor="start"
                    transform="translate(0,0)"
                    y={-9999}
                  >
                    0
                  </text>
                  <text
                    x={5}
                    textAnchor="start"
                    transform="translate(0,0)"
                    y={320}
                    opacity={1}
                  >
                    20
                  </text>
                  <text
                    x={5}
                    textAnchor="start"
                    transform="translate(0,0)"
                    y={245}
                    opacity={1}
                  >
                    40
                  </text>
                  <text
                    x={5}
                    textAnchor="start"
                    transform="translate(0,0)"
                    y={169}
                    opacity={1}
                  >
                    60
                  </text>
                  <text
                    x={5}
                    textAnchor="start"
                    transform="translate(0,0)"
                    y={94}
                    opacity={1}
                  >
                    80
                  </text>
                  <text
                    x={0}
                    textAnchor="start"
                    transform="translate(0,0)"
                    y={-9999}
                  >
                    100
                  </text>
                </g>
                <g
                  className="highcharts-label highcharts-tooltip highcharts-tooltip-0            highcharts-color-1"
                  data-z-index={8}
                  transform="translate(1,-9999)"
                  opacity={0}
                  visibility="visible"
                >
                  <path
                    className="highcharts-label-box highcharts-tooltip-box"
                    d="M 4.5 0.5 L 207.5 0.5 C 211.5 0.5 211.5 0.5 211.5 4.5 L 211.5 68.5 C 211.5 72.5 211.5 72.5 207.5 72.5 L 4.5 72.5 C 0.5 72.5 0.5 72.5 0.5 68.5 L 0.5 4.5 C 0.5 0.5 0.5 0.5 4.5 0.5" />
                </g>
              </svg>
              <div
                className="highcharts-label highcharts-tooltip highcharts-tooltip-0            highcharts-color-1"
                style={{
                  position: "absolute",
                  left: 1,
                  top: "-9999px",
                  opacity: 0,
                  visibility: "visible",
                }}
              >
                <span
                  data-z-index={1}
                  style={{
                    position: "absolute",
                    whiteSpace: "nowrap",
                    marginLeft: 0,
                    marginTop: 0,
                    left: 16,
                    top: 16,
                  }}
                >
                  <table>
                    <tbody>
                      <tr className="highcharts-header">
                        <th>7/18/19</th>
                      </tr>
                      <tr>
                        <td>
                          <span className="highcharts-color-1">●</span>
                          <b>Daily active users</b>

                          &nbsp;&nbsp;
                        </td>
                        <td className="highcharts-tooltip-value">42</td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FormGroup>
  );
}
